import { supabase } from './supabase';

function getFunctionsBaseUrl(): string {
  const base = import.meta.env.VITE_SUPABASE_URL;
  if (!base) throw new Error('VITE_SUPABASE_URL is not set');
  return `${base}/functions/v1`;
}

export async function getFunctionAuthHeaders(): Promise<Record<string, string>> {
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  const { data: { session } } = await supabase.auth.getSession();

  // For authenticated-only functions we require a session token.
  const accessToken = session?.access_token;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  // Supabase Edge Functions generally expect apikey + user JWT for auth.
  if (anonKey) headers.apikey = anonKey;
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;

  return headers;
}

export async function functionsFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const url = `${getFunctionsBaseUrl()}${path.startsWith('/') ? path : `/${path}`}`;
  const headers = await getFunctionAuthHeaders();

  const response = await fetch(url, {
    ...init,
    headers: {
      ...headers,
      ...(init.headers ? (init.headers as Record<string, string>) : {}),
    },
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = (data && (data.error || data.details)) ? `${data.error ?? 'Request failed'}${data.details ? `: ${data.details}` : ''}` : 'Request failed';
    throw new Error(message);
  }
  return data as T;
}


